/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  /** */
  // const valid_map = ['admin', 'editor']
  // return valid_map.indexOf(str.trim()) >= 0
  if (str.length === 0) {
    return false
  } else {
    return true
  }
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isEmpty(str) {
  return str === '' || str === null || str === undefined || str.length === 0
}

/**
 *
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validataUserName(rule, value, callback) {
  const pattern = /^[a-zA-Z][a-zA-Z0-9_-]{3,15}$/
  if (value === '') {
    callback(new Error('请填写用户名'))
  } else {
    if (!pattern.test(value)) {
      callback(new Error('用户名不符合规则'))
    } else {
      callback()
    }
  }
}

/**
 *
 * @param {*} rule
 * @param {*} value
 * @param {*} postForm
 * @param {*} callback
 */
export function validatePass(rule, value, postForm, callback) {
  // const pPattern = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/
  if (value === '') {
    callback(new Error('请输入密码'))
  } else {
    if (value.length < 6) {
      callback(new Error('密码至少6位'))
    } else {
      if (this.postForm.confirmPassword !== '') {
        this.$refs.userForm.validateField('confirmPassword')
      }
    }
    callback()
  }
}

/**
 *
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validatePass2(rule, value, callback) {
  if (value === '') {
    callback(new Error('请再次输入密码'))
  } else if (value !== this.postForm.password) {
    callback(new Error('两次输入密码不一致!'))
  } else {
    callback()
  }
}

/**
 *
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validatePhoneNumber(rule, value, callback) {
  const pattern = /^1[3-9]\d{9}$/
  if (value === '' || value === undefined) {
    callback(new Error('请输入手机号'))
  } else if (!pattern.test(value)) {
    callback(new Error('手机号不合法'))
  } else {
    callback()
  }
}
